import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/views/login'
import Home from '@/views/home'
import Brand from '@/views/brand'
import Classify from "@/views/classify";
import Client from "@/views/client";
import Search from "@/views/search";
import SetMenu from "@/views/setMenu";
import WxLogin from "@/views/wxLogin";
import Collect from '@/views/collect'
import NewProduct from '@/views/newProduct'
import BrandDetails from "@/views/brandDetails";
import Classification from "@/views/classification";
import ThreeClass from "@/views/threeClass";
import ImgDetails from "@/views/imgDetails";

Vue.use(Router)

export default new Router(
  {
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/brand',
      name: 'brand',
      component: Brand
    },
    {
      path: '/classify',
      name: 'classify',
      component: Classify
    },
    {
      path: '/client',
      name: 'client',
      component: Client
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/setMenu',
      name: 'setMenu',
      component: SetMenu
    },
    {
      path: '/collect',
      name: 'collect',
      component: Collect
    },
    {
      path: '/wxLogin',
      name: 'WxLogin',
      component: WxLogin
    },
    {
      path: '/newProduct',
      name: 'NewProduct',
      component: NewProduct
    },
    {
      path: '/brandDetails',
      name: 'BrandDetails',
      component: BrandDetails
    },
    {
      path: '/classification',
      name: 'Classification',
      meta:{
        keepAlive:true
      },
      component: Classification
    },
    {
      path: '/threeClass',
      name: 'ThreeClass',
      component: ThreeClass
    },
    {
      path: '/imgDetails',
      name: 'ImgDetails',
      component: ImgDetails
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js